<template>
  <el-dialog :title="$t('StockRemainQuery.orderConfirm')" :visible.sync="dialogvisible"> 
        <div class="list-contain">
            <div class="head-contain">
                <div class="field-contain" style="width: 100%;">
                    <span>{{ $t('StockRemainQuery.Address') }}</span>
                    <el-select v-model="Address" placeholder="" size="small" @change="ChangeAddr">
                        <el-option v-for="item in addrTable" :key="item.AddrId" :label="item.Address"
                            :value="item.AddrId"></el-option>
                    </el-select>
                </div>
                <div class="field-contain">
                    <span>{{ $t('StockRemainQuery.ContactPer') }}</span>
                    <el-input v-model="ContactPer" :placeholder="$t('salSalesOrder.inputpls')" size="small" :disabled="true"></el-input>
                </div>
                <div class="field-contain">
                    <span>{{ $t('StockRemainQuery.PhoneNumber') }}</span>
                    <el-input v-model="PhoneNumber" :placeholder="$t('salSalesOrder.inputpls')" size="small" :disabled="true"></el-input>
                </div>
                <div class="field-contain">
                    <span>{{ $t('StockRemainQuery.InvoType') }}</span>
                    <el-select v-model="X_InvoType" placeholder="" size="small" :disabled="InvoDisabled">
                        <el-option v-for="item in InvoTypeTable" :key="item.InvoTypeId" :label="item.InvoTypeName"
                            :value="item.InvoTypeId"></el-option>
                    </el-select>
                </div>
            </div>
        </div>
        <div class="title-row">
            <span>{{ orderTableTitle }}</span>
        </div>
        <el-table v-loading="dialogloading" :data="dialogdata" height="44vh" class="dialogtable">
            <el-table-column :width="WidthControl('X_BPMaterialId',dialogdata)" prop="X_BPMaterialId" label="ItemCode"></el-table-column>
            <el-table-column :min-width="WidthControl('X_BPMaterialName',dialogdata)" prop="X_BPMaterialName" label="ItemName"></el-table-column>
            <el-table-column :min-width="WidthControl('X_Addr',dialogdata)" prop="X_Addr" :label="$t('StockRemainQuery.wareHouseAddress')"></el-table-column>
            <el-table-column :min-width="WidthControl('X_ColorId',dialogdata,3)" prop="X_ColorId" :label="$t('StockRemainQuery.color')"></el-table-column>
            <el-table-column :min-width="WidthControl('X_Length',dialogdata,2)" prop="X_Length" align="right" :label="$t('StockRemainQuery.length')"></el-table-column>
            <el-table-column :min-width="WidthControl('X_LUnitId',dialogdata,4)" prop="X_LUnitId" :label="$t('StockRemainQuery.lengthUnit')"></el-table-column>
            <el-table-column :min-width="WidthControl('X_BizPartnerName',dialogdata)" prop="X_BizPartnerName" :label="$t('StockRemainQuery.supplier')"></el-table-column>
            <el-table-column :min-width="WidthControl('orderNum',dialogdata)" prop="orderNum" :label="$t('StockRemainQuery.orderNum')"></el-table-column>
            <el-table-column prop="option" :label="$t('Download.operation')" width="100">
                <template slot-scope="scope">
                    <div class="button option-icon" @click="Delete(scope.$index)">
                        <svg-icon  icon-class="delete" />
                    </div>
                </template>
            </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button type="reset" @click="Cancel">{{ $t('button.Cancel') }}</el-button>
        <el-button type="primary" @click="OrderCheck" v-loading.fullscreen.lock="fullscreenLoading">{{ $t('StockRemainQuery.Confirm') }}</el-button>
      </div>
    </el-dialog>
</template>
<script>
export default{
    data(){
        return{
            dialogvisible:false,
            Address:'',
            addrTable:[],
            ContactPer:'',
            PhoneNumber:'',
            InvoDisabled:false,
            X_InvoType:'',
            InvoTypeTable:[],
            dialogdata:[],
            dialogloading:false,
            orderTableTitle:this.$t('StockRemainQuery.OrderTableTitle').format(0),
            fullscreenLoading:false,
        }
    },
    methods:{
        async GetOrderConfirmList(table){
            this.dialogvisible = true;
            this.dialogloading = true;
            this.axiosInvoke(this.YMBillHandlerUrl,{
                action: "getcustaddr", 
            },res => {
                const data = res.data;
                this.X_InvoType=data.X_InvoType;
                this.InvoDisabled=this.X_InvoType!=99?true:false;
                this.addrTable = data.DataTable;
                if(this.addrTable.length>0){
                    this.Address=this.addrTable[0].AddrId;
                    this.ContactPer=this.addrTable[0].LinkMan;
                    this.PhoneNumber=this.addrTable[0].TelNo;
                }
                this.InvoTypeTable = data.InvoTypeTable;
                this.dialogloading = false;
            },false,true);
            this.dialogdata=JSON.parse(JSON.stringify(table));
            this.orderTableTitle=this.$t('StockRemainQuery.OrderTableTitle').format(table.length);
        },
        ChangeAddr(value){
            this.addrTable.forEach(v=>{
                if(v.AddrId==value){
                    this.ContactPer=v.LinkMan;
                    this.PhoneNumber=v.TelNo;
                }
            })
        },
        Delete(index){
            this.dialogdata.splice(index,1);
            this.orderTableTitle=this.$t('StockRemainQuery.OrderTableTitle').format(this.dialogdata.length);
        },
        Cancel(){
            this.dialogvisible = false;
        },
        OrderCheck(){
            this.$emit('order-item',this.dialogdata);
            this.dialogvisible = false;
            this.fullscreenLoading = true;
            this.axiosInvoke(this.YMBillHandlerUrl,{
                action: "stockorder", 
                table:JSON.stringify(this.dialogdata),
                AddrId:this.Address,
                X_InvoType:this.X_InvoType,
            },res => {
                this.fullscreenLoading = false;
                const data = res.data;
                if (data.msg) {
                    this.$alert(data.msg, this.$t("comm.tip"),{confirmButtonText: this.$t("comm.confirm")});
                }
            },false,true);
        }
    }
}
</script>
<style>
.el-dialog{
    min-width: 115vh;
    margin-top: 8vh;
}
.el-dialog__title{
    font-weight: bold;
}
.list-contain {
    display: flex;
    padding: 10px 0px;    
    /* border: 1px solid rgb(235, 233, 233); */
}

.head-contain {
    padding: 0 20px;
    width: 100%;
    display: flex;
    flex-wrap: wrap;
}

.el-select {
    width: 100%;
}

.field-contain {
    width: 49%;
    padding-right: 1%;
    display: flex;
    flex-wrap: nowrap;
    padding-bottom: 10px;
}

.field-contain>span {
    min-width: 70px;
    color: black;
    font-size: 14px;
    margin: auto;
    white-space: nowrap;
}

.title-row{
    padding:16px 0;
    font-weight: bold;
    color: #303133;
}
.dialogtable th.el-table__cell {
    background-color: #f9f9f9;
}
</style>